export default __webpack_public_path__ + "static/media/pruvodce_sebepoznanim_konfety.c58f6ac2.jpg";